import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import UnitPlanDetails from "UnitPlanDetails";
export default store => {
  return {
    path: ":tagId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "unitPlans" */ "./component"),
          import(
            /* webpackChunkName: "unitPlans" */ "UnitPlans/modules/UnitPlanModule"
          ),
          import(
            /* webpackChunkName: "unitPlans" */ "IBPlanner/modules/IBPlannerModule"
          ),
        ]).then(([importedModule0, importedModule1, importedModule2]) => {
          const component = importedModule0.default;
          const unitPlanModule = importedModule1.default;
          const plannerReducer = importedModule2.default;
          injectReducer(store, {
            key: "planner",
            reducer: plannerReducer,
          });
          injectReducer(store, {
            key: "unitPlans",
            reducer: unitPlanModule,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [UnitPlanDetails(store)],
  };
};
